/**
 *  Custom sections that are not in the interview JSON-structure.
 *
 *  PRIMARY_PHYSICIAN: Is not included in interview, but should be part of the flow.
 *  PrimaryPhysician capture is currently appended to pages array as a mock.
 *
 *  WELCOME_SECTION: The welcome page that displays before starting the interview.
 *  This page does not come from the backend, and must be manually set and shown.
 *
 */
export enum CustomPages {
  CUSTOM_PAGE = "CUSTOM_PAGE",
}

export enum CustomSections {
  PRIMARY_PHYSICIAN = "PRIMARY_PHYSICIAN",
  WELCOME_MESSAGE = "WELCOME_MESSAGE",
}
